import React, { CSSProperties, FC, ReactNode, useState } from 'react';

import { Link } from 'react-router-dom';

import Utils from '../../shared/utils';
import { Orderlist } from '../../../models/OrderList';
import { useTranslation } from 'react-i18next';
import FormatCurrency from '../../shared/utils/formatCurrency';
import { DropDownMenu } from '../../shared/common/DropDownMenu';

type Props = {
    readonly selectionLists: ReadonlyArray<Orderlist>;
    readonly arrowStyle?: CSSProperties;
    readonly iconCode?: string;
    readonly htmlLabel?: ReactNode;
    readonly onItemClick?: (list: Orderlist) => Promise<void>;
};

const SimpleSelectionListDropDown: FC<Props> = props => {
    const [expanded, setExpanded] = useState(false);
    const { t } = useTranslation();

    // TODO [i18n] css: adjust dropdown size (all lists)
    return (
        <DropDownMenu
            expanded={expanded}
            onToggleClick={() => setExpanded(!expanded)}
            onClickOutside={() => setExpanded(false)}
            onClick={() => setExpanded(!expanded)}
            align="left"
            gap={10}
            className="expanded-dd bt bt-bordered bt-sl-bar fl-none dd-a-r"
            arrowStyle={props.arrowStyle}
            iconCode={props.iconCode}
            htmlLabel={props.htmlLabel}
            label={t('selectionList.allLists')}
        >
            {props.selectionLists.map(list => {
                let eAudiobooks: ReactNode = null;
                let eBooks: ReactNode = null;
                let ePress: ReactNode = null;
                if (list.eaudiobooksAmount) {
                    eAudiobooks = (
                        <span className="marker-badge display-inline-flex">
                            <i className="bolinda-icons">audiobook</i>
                            <span>{list.eaudiobooksAmount}</span>
                        </span>
                    );
                }
                if (list.ebooksAmount) {
                    eBooks = (
                        <span className="marker-badge display-inline-flex">
                            <i className="bolinda-icons">book</i>
                            <span>{list.ebooksAmount}</span>
                        </span>
                    );
                }

                if (list.epressAmount) {
                    ePress = (
                        <span className="marker-badge display-inline-flex gild">
                            <i className="icon emagazine-filled emagazine-cart" />
                            <span>{list.epressAmount}</span>
                        </span>
                    );
                }

                const selectionListEntryInner = (
                    <span className="display-block">
                        <span className="display-block">{Utils.truncate(list.listName)}</span>
                        <span className="display-block">
                            <span className="marker-badge">
                                {t('numberFormat.numberWithCurrencySymbol', {
                                    val: FormatCurrency.convertIntegerToCurrencyFormat(list.totalValue),
                                    currencySymbol: FormatCurrency.mapCurrencyToSymbol(list.currency)
                                })}
                            </span>
                            {eAudiobooks}
                            {eBooks}
                            {ePress}
                        </span>
                        {list.lastModifiedAt ? (
                            <span className="display-block small">
                                {t('marketing.productGroups.lastEdited', { val: list.lastModifiedAt ?? 0 })}
                            </span>
                        ) : null}
                    </span>
                );

                const selectionListEntryWrapper = !props.onItemClick ? (
                    <Link to={`/orderlists/${list.id}`} onClick={() => setExpanded(false)}>
                        {selectionListEntryInner}
                    </Link>
                ) : (
                    <a
                        onClick={() => {
                            setExpanded(false);
                            props.onItemClick!(list);
                        }}
                    >
                        {selectionListEntryInner}
                    </a>
                );

                return <li key={`selectionList-${list.id}`}>{selectionListEntryWrapper}</li>;
            })}
        </DropDownMenu>
    );
};

(SimpleSelectionListDropDown as any).defaultProps = {
    selectionLists: []
};

export default SimpleSelectionListDropDown;
